import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectPersonalAccidentSCTIStep = (state) => state.get('personalAccidentSCTIStep');

const makeSelectPersonalAccidentSCTIStep = () => createSelector(
  selectPersonalAccidentSCTIStep,
  (PersonalAccidentSCTIStepState) => ({
    isThisClaimRelatedToPersonalAccident: mapWithDefault(
      PersonalAccidentSCTIStepState,
      () => PersonalAccidentSCTIStepState.getIn(['form', 'isThisClaimRelatedToPersonalAccident']),
      ''
    ),

    isThisClaimRelatedToLossOfLifeCausedByAnInjury: mapWithDefault(
      PersonalAccidentSCTIStepState,
      () => PersonalAccidentSCTIStepState.getIn(['form', 'isThisClaimRelatedToLossOfLifeCausedByAnInjury']),
      ''
    ),

    didTheInjuryLeaveYouPermanentlyDisabled: mapWithDefault(
      PersonalAccidentSCTIStepState,
      () => PersonalAccidentSCTIStepState.getIn(['form', 'didTheInjuryLeaveYouPermanentlyDisabled']),
      ''
    ),

    didTheInjuryResultInYourInabilityToReturnToWork: mapWithDefault(
      PersonalAccidentSCTIStepState,
      () => PersonalAccidentSCTIStepState.getIn(['form', 'didTheInjuryResultInYourInabilityToReturnToWork']),
      ''
    ),

    dateYouWereOriginallyDueBackAtWork: mapWithDefault(
      PersonalAccidentSCTIStepState,
      () => PersonalAccidentSCTIStepState.getIn(['form', 'dateYouWereOriginallyDueBackAtWork']),
      ''
    ),

    infoClaimRelatedToPersonalAccidentItems: mapWithDefault(PersonalAccidentSCTIStepState, () => PersonalAccidentSCTIStepState.getIn(['form', 'infoClaimRelatedToPersonalAccidentItems']) && PersonalAccidentSCTIStepState.getIn(['form', 'infoClaimRelatedToPersonalAccidentItems']).toJS(), ''),
    infoClaimRelatedToLossOfLifeItems: mapWithDefault(PersonalAccidentSCTIStepState, () => PersonalAccidentSCTIStepState.getIn(['form', 'infoClaimRelatedToLossOfLifeItems']) && PersonalAccidentSCTIStepState.getIn(['form', 'infoClaimRelatedToLossOfLifeItems']).toJS(), ''),
    infoDidTheInjuryLeaveYouPermanentlyDisabledItems: mapWithDefault(PersonalAccidentSCTIStepState, () => PersonalAccidentSCTIStepState.getIn(['form', 'infoDidTheInjuryLeaveYouPermanentlyDisabledItems']) && PersonalAccidentSCTIStepState.getIn(['form', 'infoDidTheInjuryLeaveYouPermanentlyDisabledItems']).toJS(), ''),
    infoYourInabilityToReturnToWorkItems: mapWithDefault(PersonalAccidentSCTIStepState, () => PersonalAccidentSCTIStepState.getIn(['form', 'infoYourInabilityToReturnToWorkItems']) && PersonalAccidentSCTIStepState.getIn(['form', 'infoYourInabilityToReturnToWorkItems']).toJS(), ''),
  })
);

const makeSelectPersonalAccidentSCTIStepErrors = () =>
  createSelector(selectPersonalAccidentSCTIStep, (state) => state.get('errors'));

export {
  makeSelectPersonalAccidentSCTIStep,
  makeSelectPersonalAccidentSCTIStepErrors,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.SCTI.PersonalAccident/selectors.js